export const KeyCountStateMenu = {
    ORDERS: 'orders',
};